module.exports = __webpack_public_path__ + "img/BML-Website-Logo.dbe2c2b7.png";